import { Box, Typography, Button, Stack, TextField, CircularProgress, IconButton, FormLabel, useTheme } from '@mui/material';
import { IconEye, IconEyeClosed } from '@tabler/icons-react';
import { useState } from 'react';
import { dispatch } from 'src/store/Store';
import { setToastMessage } from 'src/store/my_pages/app';
import axiosIn from 'src/middlewares/axiosInterceptor';
import { getApiUrl, apiConfig } from 'src/config/apiConfig';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import PasswordStrengthBar from 'src/my_pages/PasswordStrengthBar';

const ChangeEmailForm = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const tokenParts = token?.split('~ne=');
  const base64Email = tokenParts?.[1];
  const email = atob(base64Email);

  // const decodedToken = decodeURIComponent(token); // URL-decode

  // const base64Email = decodedToken.split('ne=')[1]; // Extract Base64 email

  const [fd, _setfd] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [showPass, setShowPass] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const theme = useTheme();
  const navigate = useNavigate();

  const setFd = (key: string, value: any) => {
    _setfd((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async () => {
    // dispatch(setToastMessage({ msg: 'Server is not available for this operation currently', color: 'warning' }));
    // return;
    setIsLoading(true);
    try {
      if (fd.newPass !== fd.confirmNewPass) {
        dispatch(setToastMessage({ msg: 'Passwords do not match', color: 'error' }));
        return;
      }

      const data = {
        token: token,
      };

      const url = getApiUrl(apiConfig.email_change_confirm);
      const res = await axiosIn.post(url, data);

      if (res.status === 200) {
        navigate('/email-verified');
        dispatch(setToastMessage({ msg: 'Email changed successfully', color: 'success' }));
        _setfd({});
      }
    } catch (error: any) {
      const errMsg = error.response?.data?.[0]?.message || Object.values(error.response?.data?.errors)?.toString() || 'Error';
      dispatch(setToastMessage({ msg: errMsg, color: 'error' }));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box color={theme.palette.text.primary}>
      <Typography color="textSecondary" textAlign="start" variant="body1" sx={{ mb: 2, mt: 4, lineHeight: 1.5, whiteSpace: 'break-spaces', fontSize: 'medium' }}>
        To proceed with updating your SecuSeek account email to <b>{email}</b>, please confirm this change by clicking the button below.
      </Typography>

      <Box mt={'48px'}>
        <Button disabled={fd.newPass !== fd.confirmNewPass} color="primary" variant="contained" size="large" fullWidth onClick={handleSubmit}>
          Confirm {isLoading && <CircularProgress color="primary" size={20} sx={{ mt: 0, mx: 2 }} />}
        </Button>
      </Box>
    </Box>
  );
};

export default ChangeEmailForm;
